import { Component, AfterViewInit, OnInit, ViewChild, ElementRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first, map } from 'rxjs/operators';

import { AlertService, ExamService } from '../_services';
import { Globals } from '../_helpers';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { VoiceRecognitionService } from '../service/voice-recognition.service'
import { HttpHeaders, HttpClient } from '@angular/common/http';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

const reader = new FileReader();
const formData: FormData = new FormData();
declare const monaco: any;
declare const editor: any;
@Component({
  selector: 'app-descriptive-exam',
  templateUrl: './descriptive-exam.component.html',
  styleUrls: ['./descriptive-exam.component.css'],
  providers: [VoiceRecognitionService]
})

export class DescriptiveExamComponent implements OnInit {
  @ViewChild('optionsubmitSwal') private optionsubmitSwal: SwalComponent;
  @ViewChild('optionsubmitconfirmSwal') private optionsubmitconfirmSwal: SwalComponent;
  @ViewChild('examsubmitconfirmSwal') private examsubmitconfirmSwal: SwalComponent;
  @ViewChild('timeoverSwal') private timeoverSwal: SwalComponent;
  @ViewChild('noanyanswerSwal') private noanyanswerSwal: SwalComponent;
  @ViewChild('mandatorySwal') private mandatorySwal: SwalComponent;
  @ViewChild('inputFile') attachInputVariable: ElementRef;
  @ViewChild('imagesizeSwal') imagesizeSwal: SwalComponent;
  @ViewChild('docsizeSwal') docsizeSwal: SwalComponent;
  @ViewChild('LanguageSwal') LanguageSwal: SwalComponent;
  @ViewChild('editorContainer') editorContainer: ElementRef;
  
codeeditor: any;
optionsedit = {
  theme: 'vs-dark',
  //language: 'javascript',  // Default language
  language: 'python',  
  //language: 'javascript', //'javascript',  
  automaticLayout: true,
  formatOnType: true,
  foldingStrategy: 'indentation', 
  showFoldingControls: 'always'
};

code: string = `# Write your code here `; 
 editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '25rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['link', 'unlink', 'image', 'video'], ['insertImage', 'insertVideo']
    ]

  };

  public alertOption: SweetAlertOptions = {};
  matcher = new MyErrorStateMatcher();
  @HostListener('window:keyup', ['$event'])
  onKeyupHandler(event: KeyboardEvent) {
    /*console.log(event.keyCode);*/
      if (event.keyCode === 123 || event.keyCode === 67 ||event.keyCode === 17)
          //this.autoSubmitAnswers('manual');
          /*console.log(event.keyCode);*/
          event.stopPropagation();
  }
  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }
  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
  event.preventDefault();
  }  
  studentName: string = '';
  studentCode: string = '';
  optionIndexText = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
  answerdObj = {};
  notSubmitObj = [];
  answeredQuestObj = [];
  questArr = [];
  loading = false;
  indexClasses: string;
  timershow: string;
  returnUrl: string;
  maxMarks: number;
  duration: number = 0;
  type: string;
  totalQuestion: number;
  question: string;
  questionInst: string;
  index: number = 1;
  answer_id: number;
  question_id: number;
  deficulty_lebel: number = 0;
  userData = {};
  settings = {};
  options = [];
  distance: any;
  totalAnswered: number = 0;
  totalSubmited: number = 0;
  totalVisited: number = 0;
  totalNotAnswered: number = 0;
  interval;
  intervaltime;
  settime;
  isPause = false;
  isResetBtn = false;
  visitedQuesObj = {};
  isSubmit = false;
  isPauseBtn = false;
  instructions = [];
  nativeWindow: any;
  totalTimeTake: number = 0;
  timeTaken: number = 0;
  timeRemain: number = 0;
  totalExamTime;
  prevques = [];

  isMedia = false;
  qaudioUrl: string = '';
  qvideoUrl: string = '';
  qimageUrl: string = '';
  ssclogo: string = '';
  surveyUrl: string = '';
  isPicTaken;
  imagePath;
  noofpic: number = 0;
  isDone = true;
  isSpeech = true;
  speechLang = 'en-GB';
  prevIndex: number = 1;
  lock_status = 0;
  spendTime: number = 0;
  radioSelected: number;
  src
  imgs
  canvase = false;
  anstype: number = 1;
  ans: string
  attach: number
  attachfile: string
  attach_type: number
  fileToLoad: File = null;
  fileInput;
  file: File | null = null;
  context;
  textValue: string = '';
  remain_minute: number;
  subject;
  nos; 
  apiinterval;
  freezestatus: number = 0;
  isTextConversion = false;
  primarychecked: number = 1;
  isCodeEditor = false;
  editor: any;
  languageType: any;
  editorInstance: any;
  code_lang: string = '';

  /* Chart Variable */
  //public pieChartLabels: string[] = ['Answered', 'Submitted', 'Visitted', 'Not attempted'];
  public pieChartLabels: string[] = ['Attempted', 'Not attempted'];
  public pieChartData: number[] = [];
  public pieChartType: string = 'pie';
  public pieChartLegend = false;
  public chartColors: any[] = [{
   // backgroundColor: ["#44e51e", "#FF7272", "#ce03dc", "#c4c4c4"]
    backgroundColor: ["#44e51e", "#c4c4c4"]
  }];



  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private examService: ExamService,
    private alertService: AlertService,
    private globals: Globals,
    private spinner: NgxSpinnerService,
    private domSanitizer: DomSanitizer,
    public service : VoiceRecognitionService,
    private http: HttpClient
  ) {
   this.service.init()
  }
 
  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('currentUser'));
    this.settings = JSON.parse(sessionStorage.pkshn_exam_set);
    this.studentName = this.userData['name'];
    this.studentCode = this.userData['code'];
    //this.loadMonacoEditor();
    if (this.settings['submit'] == 0) {
      this.isSubmit = true;
    }
    if (this.settings['student_pause'] == 0) {
      this.isPauseBtn = true;
    }
    if (this.settings['text_speech'] == 0) {
      this.isSpeech = false;
    }
    if (this.settings['exam_logo'] != "") {
      this.ssclogo = this.settings['exam_logo'];
    }
    if (this.settings['text_conversion'] == 1) {
      this.isTextConversion = true;
    }
    if (this.settings['editor_type'] == 1) {
      this.isCodeEditor = true;
      this.code_lang = this.settings['code_lang'];
      if(this.settings['id_code_language'] == 1 || this.settings['id_code_language'] == 2)
      {
        this.languageType = 'java'; 
      }
      else if(this.settings['id_code_language'] == 4 || this.settings['id_code_language'] == 5 || this.settings['id_code_language'] == 6)
      {
        this.languageType = 'python'; 
      }    
      else if(this.settings['id_code_language'] == 3)
      {
        this.languageType = 'javascript'; 
      }  
    } 
    
    // get return url from route parameters or default to '/'
    this.returnUrl = '/';

    /* call function for first question and exam info */
    this.getExams();
    this.getLanguages();
    this.apiinterval = setInterval(() => {
        this.descriptiveFreeze(); 
    }, 15000);
     //this.textValue = 'Enter text here...';
    if(this.isTextConversion == true)
    {
     this.getSecondaryLang();     
    }   
  }
  // Add Event Handler
  onInitHandler(event: any){    
    this.codeeditor = event.editor;
    this.editorInstance = event;
      // Register additional languages. javascript, java, python, xml
      monaco.languages.register({ id: 'java' });
      monaco.languages.register({ id: 'xml' });
      monaco.languages.register({ id: 'python' });
      //console.log('this.languageType: '+this.languageType);
      //monaco.languages.register({ id: this.languageType });
    
      monaco.languages.setLanguageConfiguration('xml', {
        comments: { lineComment: '<!-- -->' },
      });

      monaco.languages.setMonarchTokensProvider('python', {
        keywords: [
          'and', 'as', 'assert', 'async', 'await', 'break', 'class', 'continue', 'def',
          'del', 'elif', 'else', 'except', 'False', 'finally', 'for', 'from', 'global',
          'if', 'import', 'in', 'is', 'lambda', 'None', 'nonlocal', 'not', 'or', 'pass',
          'raise', 'return', 'True', 'try', 'while', 'with', 'yield'
        ],
        operators: [
          '=', '>', '<', '!', '~', '?', ':', '==', '<=', '>=', '!=', '&&', '||', '++', '--',
          '+', '-', '*', '/', '&', '|', '^', '%', '<<', '>>', '>>>', '+=', '-=', '*=', '/=',
          '&=', '|=', '^=', '%=', '<<=', '>>=', '>>>='
        ],
        symbols: /[=><!~?:&|+\-*\/\^%]+/,
        tokenizer: {
          root: [
            [/[a-zA-Z_]\w*/, {
              cases: {
                '@keywords': 'keyword',
                '@default': 'identifier'
              }
            }],
            [/[ \t\r\n]+/, ''],
            [/#.*/, 'comment'],
            [/\d+/, 'number'],
            [/[{}()\[\]]/, '@brackets'],
            [/@symbols/, { cases: { '@operators': 'operator', '@default': '' } }],
            [/"([^"\\]|\\.)*$/, 'string.invalid'],  // non-teminated string
            [/'([^'\\]|\\.)*$/, 'string.invalid'],  // non-teminated string
            [/"/, { token: 'string.quote', bracket: '@open', next: '@string_double' }],
            [/'/, { token: 'string.quote', bracket: '@open', next: '@string_single' }],
          ],
          string_double: [
            [/[^\\"]+/, 'string'],
            [/\\./, 'string.escape.invalid'],
            [/"/, { token: 'string.quote', bracket: '@close', next: '@pop' }]
          ],
          string_single: [
            [/[^\\']+/, 'string'],
            [/\\./, 'string.escape.invalid'],
            [/'/, { token: 'string.quote', bracket: '@close', next: '@pop' }]
          ]
        }
      });
      monaco.languages.setLanguageConfiguration('python', {
        comments: {
          lineComment: '#'
        },
        brackets: [['{', '}'], ['[', ']'], ['(', ')']],
        autoClosingPairs: [
          { open: '(', close: ')' },
          { open: '[', close: ']' },
          { open: '{', close: '}' },
          { open: '"', close: '"' },
          { open: "'", close: "'" }
        ]
      });     
// Define the Monarch Token Provider for Java
monaco.languages.setMonarchTokensProvider('java', {
  keywords: [
    'abstract', 'continue', 'for', 'new', 'switch', 'assert', 'default', 'goto', 'package', 'synchronized',
    'boolean', 'do', 'if', 'private', 'this', 'break', 'double', 'implements', 'protected', 'throw',
    'byte', 'else', 'import', 'public', 'throws', 'case', 'enum', 'instanceof', 'return', 'transient',
    'catch', 'extends', 'int', 'short', 'try', 'char', 'final', 'interface', 'static', 'void', 'class',
    'finally', 'long', 'strictfp', 'volatile', 'const', 'float', 'native', 'super', 'while', 'true', 'false'
  ],
  typeKeywords: [
    'byte', 'short', 'int', 'long', 'float', 'double', 'boolean', 'char', 'void'
  ],
  operators: [
    '=', '>', '<', '!', '~', '?', ':', '==', '<=', '>=', '!=', '&&', '||', '++', '--', '+', '-', '*', '/',
    '&', '|', '^', '%', '<<', '>>', '>>>', '+=', '-=', '*=', '/=', '&=', '|=', '^=', '%=', '<<=', '>>=', '>>>='
  ],
  symbols: /[=><!~?:&|+\-*\/\^%]+/,
  escapes: /\\(?:[btnfr"'\\]|u[0-9A-Fa-f]{4})/,
  tokenizer: {
    root: [
      // Identifiers and keywords
      [/[a-zA-Z_]\w*/, {
        cases: {
          '@typeKeywords': 'keyword.type',
          '@keywords': 'keyword',
          '@default': 'identifier'
        }
      }],

      // Whitespace
      { include: '@whitespace' },

      // Delimiters and operators
      [/[{}()\[\]]/, '@brackets'],
      [/@symbols/, { cases: { '@operators': 'operator', '@default': '' } }],

      // Numbers
      [/\d*\.\d+([eE][\-+]?\d+)?[fFdD]?/, 'number.float'],
      [/0[xX][0-9a-fA-F]+[Ll]?/, 'number.hex'],
      [/\d+[lL]?/, 'number'],

      // Strings
      [/"([^"\\]|\\.)*$/, 'string.invalid'],  // Non-terminated string
      [/"/, { token: 'string.quote', bracket: '@open', next: '@string' }],

      // Characters
      [/'[^\\']'/, 'string'],
      [/'/, 'string.invalid']
    ],

    whitespace: [
      [/[ \t\r\n]+/, ''],
      [/\/\*\*(?!\/)/, 'comment.doc', '@javadoc'],
      [/\/\*/, 'comment', '@comment'],
      [/\/\/.*$/, 'comment']
    ],

    comment: [
      [/[^\/*]+/, 'comment'],
      [/\*\//, 'comment', '@pop'],
      [/[\/*]/, 'comment']
    ],

    javadoc: [
      [/[^\/*]+/, 'comment.doc'],
      [/\*\//, 'comment.doc', '@pop'],
      [/[\/*]/, 'comment.doc']
    ],

    string: [
      [/[^\\"]+/, 'string'],
      [/@escapes/, 'string.escape'],
      [/\\./, 'string.escape.invalid'],
      [/"/, { token: 'string.quote', bracket: '@close', next: '@pop' }]
    ]
  }
});

// Optionally set language configurations for Java
monaco.languages.setLanguageConfiguration('java', {
  comments: {
    lineComment: '//',
    blockComment: ['/*', '*/']
  },
  brackets: [['{', '}'], ['[', ']'], ['(', ')']],
  autoClosingPairs: [
    { open: '{', close: '}' },
    { open: '[', close: ']' },
    { open: '(', close: ')' },
    { open: '"', close: '"' },
    { open: "'", close: "'" }
  ],
  surroundingPairs: [
    { open: '(', close: ')' },
    { open: '[', close: ']' },
    { open: '{', close: '}' },
    { open: '"', close: '"' },
    { open: "'", close: "'" }
  ],
  folding: {
    markers: {
      start: new RegExp("^\\s*//\\s*#region\\b"),
      end: new RegExp("^\\s*//\\s*#endregion\\b")
    }
  }
});       
   // Dynamically set the language
    //editor.getModel().setMode('python');
    //console.log(this.languageType);
    event.editor.getModel().setMode(this.languageType);
    //event.editor.getModel().setMode(this.languageType);
    //event.editor.setModelLanguage(event.editor.getModel(), this.languageType);
    
  }
  //const model = this.editorInstance.getModel();
  //monaco.editor.setModelLanguage(model, this.languageType);

speaklanguage;
selectedLanguage:string = '';
  startService(){
    this.speaklanguage = this.selectedLanguage;//'en-US';
    if(this.speaklanguage == "")
    {
      this.speaklanguage = 'en-US';
    }
    this.service.start(this.speaklanguage);
    //this.textValue = this.service.text;
  }
  display1 ='none'; //default    
  startSpeaking()
  {
    if(this.selectedLanguage == "")
    {
      this.LanguageSwal.show();
    }
    else{
      this.display1 = 'block';
      this.startService();
    }
  }
  stopService(){
    this.service.stop();
     this.display1 = 'none';
  }
  changeLanguage(value) {
    this.selectedLanguage = value;
    //console.log(this.selectedLanguage);
  }
  secondaryLang:string = '';
  primarylang;
  seclang_code: string = '';
  selected:string;
  currentlanguage: string;
  secondaryLanguage(value) {
    this.secondaryLang = value;
    this.seclang_code = this.secondaryLang.split("-")[0];
    if(this.currentlanguage != this.seclang_code)
    {   
      this.currentlanguage = this.seclang_code;
      this.googleAPI(this.primary_lang_code, this.seclang_code);
    }
  }  
  primaryLanguage() {
    if(this.currentlanguage != this.primary_lang_code)
    {
      this.currentlanguage = this.primary_lang_code;
      this.googleAPI(this.seclang_code,this.primary_lang_code);
    }
    this.selected = 'Select a language';
  }   
  googleAPI(primary_lang, secondary_land)
  {
    this.loading = true;
    this.spinner.show();
    var quest = this.question;
    const body = { q: quest, source: primary_lang, target:secondary_land };
    this.http.post<any>("https://translation.googleapis.com/language/translate/v2?key=AIzaSyBobH9FTqp_npqwcgDlwjeKAZse_v_yp6Q", body).subscribe((res: any) => {
        var translateRes = res;
        var getResponse = translateRes.data.translations;
        for (var g = 0; g < getResponse.length; g++) 
        {
          this.question = getResponse[g].translatedText;
          this.loading = false;
          this.spinner.hide();         
        }
    });
  }
  /* Get Exam data when exam UI is load */
  private getExams() {
    this.loading = true;
    this.spinner.show();
    this.options = [];
    this.questArr = [];
    this.answerdObj = {};
    this.isMedia = false;
    this.qaudioUrl = '';
    this.qvideoUrl = '';
    this.qimageUrl = '';   
    this.examService.getDescriptiveQuestion(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.settings['shuffle_ques'])
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
            let exam = data.exams;
            this.spendTime = exam.stime;
            this.type = exam.type;
            this.totalQuestion = exam.totalq;
            this.subject = exam.qp;
            this.prevques = exam.res;
            let questionData = exam.question;
            let videoFeed = exam.feed;
            this.answer_id = 0;
            this.speechLang = questionData.lang;
            this.question = questionData.question;
            if(this.isTextConversion == true)
            {
              if(this.currentlanguage != this.primary_lang_code)
              {
                this.googleAPI(this.primary_lang_code, this.seclang_code);
              }               
            }           
            this.questionInst = questionData.question_inst;
            this.maxMarks = questionData.max_marks;
            this.question_id = questionData.question_id;
            this.nos = questionData.nos;
            this.index = questionData.index;
            if (this.spendTime > 0) {
              this.spendTime = Math.ceil(this.spendTime / 60);
              this.duration = (exam.duration - this.spendTime);
            }
            else {
              this.duration = exam.duration;
            }
            if (questionData.media != '') {
              this.isMedia = true;
              if (questionData.media_type == 2) {
                this.qimageUrl = questionData.media;
              }
              else if (questionData.media_type == 3) {
                this.qaudioUrl = questionData.media;
              }
              else if (questionData.media_type == 4) {
                this.qvideoUrl = questionData.media;
              }
            }
            /* set button background color */
            this.btnStyle(this.index, 'current');

            /* Set question visited */
            this.visitedQuesObj[this.index] = 'visited';

            /* Create array for question index */
            this.createArrayQuesNoObj(this.totalQuestion, this.prevques);
            /* Set counter */
            if (sessionStorage.getItem("pkshn_dexam_time") === undefined || sessionStorage.getItem("pkshn_dexam_time") === null) {
              this.counter(this.duration);
            }
            else {
              var exam_seconds = Number(this.duration) * 60;
              var timePass = sessionStorage.getItem("pkshn_dexam_time");
              var timesplits = timePass.split(":");
              var min = Number((Math.round(Number(timesplits[0]) * 100) / 100).toFixed(2));
              var sec = (Number(timesplits[1]) / 60);
              var sec1 = Number(sec.toFixed(2));
              if(min <= 0)
              {
                  this.remain_minute = (Number(timesplits[1]) / 100);
              }
              else{
               this.remain_minute = min + sec1;               
              }              
              this.counter(this.remain_minute);
            }

            /* Timer for per question */
            this.questionAnswerTimer(questionData.time_taken);
            this.spinner.hide();

          }
          else if (data.status == 'COM_TOKEN_ERROR') {
            this.loading = false;
            this.router.navigateByUrl('/login');
            this.spinner.hide();
          }
          else {
            this.loading = false;
            //this.router.navigateByUrl('/login');
            this.spinner.hide();
          }

        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          //this.router.navigateByUrl('/login');
          this.spinner.hide();
        }
      );
  }

  /* Get Exam data by index number */
  private getQuestionByIndex() {
    this.options = [];
    this.loading = true;
    this.isMedia = false;
    this.qaudioUrl = '';
    this.qvideoUrl = '';
    this.qimageUrl = '';
    this.spinner.show();
    this.examService.getDescriptiveQuestionByIndex(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.index, this.settings['shuffle_ques'])
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {

            clearInterval(this.intervaltime);
            this.prevIndex = this.index;
            let questionData = data.question;
            this.speechLang = questionData.lang;
            this.question = questionData.question;
            if(this.isTextConversion == true)
            {
              if(this.currentlanguage != this.primary_lang_code)
              {
                this.googleAPI(this.primary_lang_code, this.seclang_code);
              }               
            }                         
            this.questionInst = questionData.question_inst;
            this.maxMarks = questionData.max_marks;
            this.question_id = questionData.question_id;
            if (questionData.media != '') {
              this.isMedia = true;
              if (questionData.media_type == 2) {
                this.qimageUrl = questionData.media;
              }
              else if (questionData.media_type == 3) {
                this.qaudioUrl = questionData.media;
              }
              else if (questionData.media_type == 4) {
                this.qvideoUrl = questionData.media;
              }
            }

            if (this.index in this.answerdObj) {
              this.answer_id = this.answerdObj[this.index];
              this.optBtnStyle(this.answer_id, this.index);
              this.btnStyle(this.index, 'answeredCurr');
              this.visitedQuesObj[this.index] = 'answered';
            }
            else {
              this.visitedQuesObj[this.index] = 'visited';
              this.btnStyle(this.index, 'current');
            }


            /* Timer for per question */
            this.questionAnswerTimer(questionData.time_taken);
            this.spinner.hide()

            /* Live Streaming */
            //this.setliveStreaming(videoFeed);                       
          }
          else {
            this.loading = false;
            //this.router.navigateByUrl('/login');
            this.spinner.hide();
          }

        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          //this.router.navigateByUrl('/login');
          this.spinner.hide();
        }
      );
  }

  /* Create array of object for number of question and lebel */
  private createArrayQuesNoObj(totalQuest, preques) {
    for (var i = 0; i < totalQuest; ++i) {
      this.questArr[i] = { index: i + 1 };
      var setColor = false;
      for (var j = 0; j < preques.length; j++) {
        if (preques[j].index === (i + 1)) {
          var answer = preques[j].answer ? 1 : 0;

          if (answer == 1 && preques[j].lock == 0 && setColor == false) {
            this.btnStyle(preques[j].index, 'answered');
            this.visitedQuesObj[preques[j].index] = 'answered';
            setColor = true;
          }
          if (answer == 1 && preques[j].lock == 0 && setColor == true) {
            this.btnStyle(preques[j].index, 'answered');
            this.visitedQuesObj[preques[j].index] = 'answered';
            setColor = true;
          }
          if (answer == 1 && preques[j].lock == 1 && setColor == false) {
            this.btnStyle(preques[j].index, 'submited');
            this.visitedQuesObj[preques[j].index] = 'submited';
            setColor = true;
          }
          else if (answer == 1 && preques[j].lock == 1 && setColor == true) {
            this.btnStyle(preques[j].index, 'submited');
            this.visitedQuesObj[preques[j].index] = 'submited';
            setColor = true;
          }
          if (answer == 0 && preques[j].lock == 0 && setColor == false) {
            this.btnStyle(preques[j].index, 'visited');
            this.visitedQuesObj[preques[j].index] = 'visited';
            setColor = true;
          }
        }
      }
    }
  }


  public getQuestionIndex(event, item) {
    if (!this.isPause && this.visitedQuesObj[item] != 'submited') {
      this.index = item;
      this.getQuestionByIndex();
    }
    this.answer_id = 0;
  }


 onBlur(event) {
    //console.log(event);
    this.ans = this.service.text;//this.textValue;
    //console.log(this.ans);
  }

/*  method(event) {
    this.ans = event.target.value
  }
*/
  public onSelectFile(selectedFile) {
          //console.log(selectedFile[0]);
    if(selectedFile[0] != 'undefined'){      
      if (selectedFile[0].type == 'image/png' || selectedFile[0].type == 'image/jpg' || selectedFile[0].type == 'image/jpeg') {
        this.attach_type = 1;
        var size = selectedFile[0].size;
        if(size >= 1048576)
        {
          this.attachInputVariable.nativeElement.value = "";
          this.imagesizeSwal.show();
          return;
        }
      } else if (selectedFile[0].type == 'application/pdf') {
        this.attach_type = 2
        var size = selectedFile[0].size;
        if(size >= 1048576)
        {
          this.attachInputVariable.nativeElement.value = "";
          this.docsizeSwal.show();
          return;
        }
      } else if (selectedFile[0].type == 'application/msword') {
        this.attach_type = 3
        var size = selectedFile[0].size;
        if(size >= 1048576)
        {
          this.attachInputVariable.nativeElement.value = "";
          this.docsizeSwal.show();
          return;
        }
      }
      else if (selectedFile[0].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        this.attach_type = 3
        var size = selectedFile[0].size;
        if(size >= 1048576)
        {
          this.attachInputVariable.nativeElement.value = "";
          this.docsizeSwal.show();
          return;
        }
      }
    }
    this.fileToLoad = selectedFile[0]; 
    var fileReader = new FileReader();
    fileReader.readAsDataURL(this.fileToLoad);
    fileReader.onload = (event: any) => {
      this.abc(event.target.result)

    };
    // console.log(this.attachfile)

  }
  public abc(a) {
    this.attachfile = a;
    //console.log(this.attachfile);
  }

  public attachment() {
    this.examService.saveAttachment(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.question_id, this.attachfile, this.attach_type, this.fileToLoad.name)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
            this.attachInputVariable.nativeElement.value = "";
          } else {

          }

        })
  }


  public clear() {
    const canvas = <HTMLCanvasElement>document.getElementById('canvas1');
    this.context = canvas.getContext('2d');
    this.context.clearRect(0, 0, 800, 300);
  }

  public text(value) {
    this.canvase = false;
    this.anstype = 1;
    document.getElementById('text')
    //console.log(" Text Value is : "+ value );
  }

  public canvas(value) {
    this.canvase = true;
    this.anstype = 2;
    document.getElementById('canvas');
    this.service.stop()
     //console.log(" Canvas Value is : "+ value );

  }

  public prevQuestion() {
    speechSynthesis.cancel();
    if (this.index > 1) {
      this.saveAndNext('prev',this.anstype);
      this.visitedQuesObj[this.index] = 'visited';
    }
  }



  public nextQuestion() { 
    speechSynthesis.cancel();
    this.service.stop();
    console.log(this.index);
    console.log(this.totalQuestion);
    if(this.anstype ==  1 && (!this.isCodeEditor))
    {
      this.ans = this.service.text;
      this.saveAndNext('next', this.anstype)
      this.visitedQuesObj[this.index] = 'visited';
    }
    else if(this.anstype ==  1 && (this.isCodeEditor))
    { 
      this.ans = this.codeeditor.getValue();    
      this.code = ''; 
      this.saveAndNext('next', this.anstype)
      this.visitedQuesObj[this.index] = 'visited';
    }
    else if(this.anstype ==  2)
    {
      var canvas = document.getElementsByTagName('canvas');
      this.src = canvas[0].toDataURL("image/png");
      var canvasnew = <HTMLCanvasElement>document.getElementById('canvasnew');
      this.imgs = canvasnew.toDataURL("image/png");
      this.saveAndNext('next', this.anstype)
    }

/*    if (this.index < this.totalQuestion) {
      var canvas = document.getElementsByTagName('canvas');
      this.src = canvas[0].toDataURL("image/png");
      var canvasnew = <HTMLCanvasElement>document.getElementById('canvasnew');
      this.imgs = canvasnew.toDataURL("image/png");
      console.log(this.imgs);
      console.log(this.ans);
    }
    else {
      this.ans = this.service.text;
      if (typeof this.ans != 'undefined' && this.ans != '') {
        this.submitSingleQuestion(this.index, this.question_id);
      }
      if(this.anstype == 2)
      {
        if (this.src != this.imgs) {
          this.submitCanvas(this.index, this.question_id);
        }  
      }
    }*/
  }

  private saveAndNext(action, anstype) {
    if(this.anstype == 1 && (this.isCodeEditor))
    {
        this.submitSingleQuestion(this.index, this.question_id);
    }
    else if(this.anstype == 1)
    {
      if (typeof this.ans != 'undefined' && this.ans != '') {
        this.submitSingleQuestion(this.index, this.question_id);
      }      
    }
    if(this.anstype == 2)
    {
      if (this.src != this.imgs) {
        this.submitCanvas(this.index, this.question_id);

      }
    }
    if(this.index < this.totalQuestion)
    {
      if (action == 'next') {
        let curind = this.getNextIndex('next', this.index + 1);
        this.index = curind;
      }
      else if (action == 'prev') {
        let curind = this.getNextIndex('prev', this.index - 1);
        this.index = curind;
      }
    }


  }

  /* On click submit button submit current index answer */
/*  public submitQuestion() {
    if (this.answer_id > 0) {
      this.optionsubmitconfirmSwal.show();
    }
    else {
      this.optionsubmitSwal.show();

    }
  }
*/
  /* submit single question with lock*/
  public submitSingleQuestion(index, question_id) {
    this.loading = true;
    this.spinner.show();
    this.lock_status = 1;
    //this.timeTaken
    //this.ans
    var spendsec = this.totalExamTime.toString().split(":");
    var minutes = 0;
    var seconds = 0, digits = 0;
    if (spendsec.length >= 1 && typeof spendsec[1] != 'undefined') {
      minutes = parseInt(spendsec[0]);
      digits = spendsec[1].toString().length;
      if (digits == 1) {
        seconds = (parseInt(spendsec[1]) / 10) * 60;
      }
      else if (digits >= 2 && digits < 3) {
        seconds = (parseInt(spendsec[1]) / 100) * 60;
      }
      else {
        seconds = (parseInt(spendsec[1]) / 1000) * 60;
      }
    }
    else {
      seconds = (this.totalExamTime * 60);
    }
    this.timeRemain = (this.duration * 60) - seconds;
    //console.log('when next'+index);
    //console.log('when next'+this.totalQuestion);
    this.examService.setDescriptiveQuestionByIndex(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], index, this.ans, question_id, this.attach, this.file, this.attach_type, this.timeTaken, this.timeRemain)
      .pipe(first())
      .subscribe(
        data => {
          if (index == this.totalQuestion && data.code == 1000) {
            //this.isDone = true;
            this.ans = '';
            //this.textValue = ''; 
            this.service.text = ''; 
            this.btnStyle(index, 'submited');
            this.visitedQuesObj[index] = 'submited';
            if (this.attachfile != null || this.attachfile != undefined) {
              this.attachment()
            }
            this.openSubmitArea();
          }
          else if (data.code == 1000) {

            this.ans = '';
            //this.textValue = ''; 
            this.service.text = ''; 
            this.btnStyle(index, 'submited');
            this.visitedQuesObj[index] = 'submited';
            if (this.attachfile != null || this.attachfile != undefined) {
              this.attachment()
            }
            this.getQuestionByIndex();
          }
          else {
            this.ans = '';
            this.loading = false;
            //this.router.navigateByUrl('/login');
          }
          this.spinner.hide();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          this.router.navigateByUrl('/login');
          this.spinner.hide();
        }
      );
  }

  public submitCanvas(index, question_id) {
    this.loading = true;
    this.spinner.show();
    this.lock_status = 1;
    this.timeTaken
    var spendsec = this.totalExamTime.toString().split(":");
    var minutes = 0;
    var seconds = 0, digits = 0;
    if (spendsec.length >= 1 && typeof spendsec[1] != 'undefined') {
      minutes = parseInt(spendsec[0]);
      digits = spendsec[1].toString().length;
      if (digits == 1) {
        seconds = (parseInt(spendsec[1]) / 10) * 60;
      }
      else if (digits >= 2 && digits < 3) {
        seconds = (parseInt(spendsec[1]) / 100) * 60;
      }
      else {
        seconds = (parseInt(spendsec[1]) / 1000) * 60;
      }
    }
    else {
      seconds = (this.totalExamTime * 60);
    }
    this.timeRemain = (this.duration * 60) - seconds;
    this.examService.savecanvasByIndex(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], index, this.src, question_id, this.timeTaken, this.timeRemain)
      .pipe(first())
      .subscribe(
        data => {
          if (index == this.totalQuestion) {
            //this.isDone = true;
            this.ans = '';
            this.clear();
            this.btnStyle(index, 'submited');
            this.visitedQuesObj[index] = 'submited';
            if (this.attachfile != null || this.attachfile != undefined) {
              this.attachment()
            }
            this.openSubmitArea();
          }
          else if (data.code == 1000) {
            this.ans = '';
            this.clear();
            this.btnStyle(index, 'submited');
            this.visitedQuesObj[index] = 'submited';
            if (this.attachfile != null || this.attachfile != undefined) {
              this.attachment()
            }
            this.getQuestionByIndex();
          }
          else {
            this.ans = '';
            this.loading = false;
            //this.router.navigateByUrl('/login');
          }
          this.spinner.hide();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          this.router.navigateByUrl('/login');
          this.spinner.hide();
        }
      );
  }





  private btnStyle(btnIndex, status) {
    setTimeout(function () {
      var currentBtn = document.getElementById('btn-' + btnIndex);
      if (typeof currentBtn != 'undefined') {
        if (status == 'answered') {
          currentBtn.classList.add('btn-answered');
          currentBtn.classList.remove('btn-current');
          currentBtn.classList.remove('btn-visited');
          currentBtn.classList.remove('btn-notvisited');
          currentBtn.classList.remove('visited-btn');
        }
        else if (status == 'submited') {
          currentBtn.classList.add('btn-submited');
          currentBtn.classList.remove('btn-current');
          currentBtn.classList.remove('btn-answered');
          currentBtn.classList.remove('btn-visited');
          currentBtn.classList.remove('btn-notvisited');
          currentBtn.classList.remove('visited-btn');
        }
        else if (status == 'visited') {
          currentBtn.classList.add('btn-visited');
          currentBtn.classList.remove('btn-current');
          currentBtn.classList.remove('btn-answered');
          currentBtn.classList.remove('btn-notvisited');
        }
        else if (status == 'answeredCurr') {
          var preBtn = document.getElementsByClassName('btn-current');
          //console.log(preBtn);
          if (typeof preBtn != 'undefined' && preBtn.length > 0) {
            for (var i = 0; i < preBtn.length; ++i) {
              preBtn[i].classList.add('btn-visited');
              preBtn[i].classList.remove('btn-current');
              if (preBtn[i].classList.contains("btn-answered")) { preBtn[i].classList.remove('btn-answered'); }
              preBtn[i].classList.remove('btn-notvisited');
              preBtn[i].classList.remove('visited-btn');
            }
          }
        }
        else if (status == 'current') {
          var preBtn = document.getElementsByClassName('visited-btn');
          if (typeof preBtn != 'undefined' && preBtn.length > 0) {
            for (var i = 0; i < preBtn.length; ++i) {
              preBtn[i].classList.add('btn-visited');
              preBtn[i].classList.remove('btn-current');
              preBtn[i].classList.remove('btn-answered');
              preBtn[i].classList.remove('btn-notvisited');
              preBtn[i].classList.remove('visited-btn');
            }
          }
          currentBtn.classList.add('visited-btn');
          currentBtn.classList.add('btn-current');
          currentBtn.classList.remove('btn-visited');
          currentBtn.classList.remove('btn-answered');
          currentBtn.classList.remove('btn-notvisited');
        }
        else if (status == 'not-answered') {
          currentBtn.classList.add('btn-notvisited');
          currentBtn.classList.remove('visited-btn');
          currentBtn.classList.remove('btn-current');
          currentBtn.classList.remove('btn-visited');
          currentBtn.classList.remove('btn-answered');
        }
      }
    }, 200);
  }

  /* Change option btn color */
  private optBtnStyle(btnIndex, indexId) {
    setTimeout(function () {
      var currentOptBtn = document.getElementById('op-' + btnIndex);
      if (typeof currentOptBtn != 'undefined') {
        if (currentOptBtn.classList.contains("isChecked")) { currentOptBtn.classList.remove('isChecked'); }
        currentOptBtn.classList.add('isChecked');
        currentOptBtn.classList.remove('isUnchecked');
      }
    }, 200);
  }


  totalTimeInSec = 0;
  currentTime = 0;
  nextImageTime = 0;


  /* Create timer according to duration */
  private counter(duration) {
    var chksec = duration.toString().split(".");
    var minutes = 0;
    var seconds = 0, digits = 0;
    if (chksec.length > 1 && typeof chksec[1] != 'undefined') {
      minutes = parseInt(chksec[0]);
      digits = chksec[1].toString().length;
      if(minutes > 0)
      {
        if (digits == 1) {
          seconds = Math.round((parseInt(chksec[1]) / 10) * 60); 
        }
        else if (digits >= 2 && digits < 3) {
          seconds = Math.round((parseInt(chksec[1]) / 100) * 60); 
        }
        else {
          seconds = Math.round((parseInt(chksec[1]) / 1000) * 60); 
        }        
      }
      else{
        seconds = chksec[1];
      }
    }
    else {
      var minutes = parseInt(duration);
    }

    this.totalTimeInSec = minutes * 60;
    if (minutes >= 0) {
      this.interval = setInterval(() => {

        if (!this.isPause) {

          this.currentTime++;
          --seconds;

          minutes = (seconds < 0) ? --minutes : minutes;

          seconds = (seconds < 0) ? 59 : seconds;

          if (minutes == 5 && seconds == 0) {
            document.getElementById('timer-id').classList.add('blink_me');
          }
          if (minutes <= 0 && seconds <= 0) {
            clearInterval(this.interval);
            sessionStorage.setItem('pkshn_dexam_time', '0:0');
            this.openSubmitArea();
            this.submitFinalExam('auto');
            this.globals.isExamOver = true;
          }
          else{
            this.timershow = minutes + ':' + seconds;
            this.totalExamTime = (duration - minutes) + ':' + seconds;
            sessionStorage.setItem('pkshn_dexam_time', this.timershow); 
          }
        }
      }, 1000);
    }
  }

  /* Pie chart */
  public openSubmitArea() {
    let visitedq = 0;
    let submitedq = 0;
    let answerdq = 0;
    let notAttemptq = 0;
    if (Object.keys(this.visitedQuesObj).length > 0) {
      for (let ansobj in this.visitedQuesObj) {
        if (this.visitedQuesObj[ansobj] == 'submited')
          submitedq++;
        else if (this.visitedQuesObj[ansobj] == 'visited')
          visitedq++;
        else if (this.visitedQuesObj[ansobj] == 'answered')
          answerdq++;
      }

      notAttemptq = this.totalQuestion - (submitedq + visitedq + answerdq);
    }
    else {
      notAttemptq = this.totalQuestion;
    }

    //this.pieChartData = [answerdq, submitedq, visitedq, notAttemptq];
    this.totalAnswered = answerdq;
    this.totalSubmited = submitedq + answerdq;
    this.totalVisited = visitedq;
    this.totalNotAnswered = notAttemptq + visitedq;
    this.pieChartData = [this.totalSubmited, this.totalNotAnswered];
    this.isDone = true;
    document.getElementById('question-area').style.display = 'none';
    document.getElementById('submited-area').style.display = 'block';
    document.getElementById('exit-test').style.display = 'none';

  }

  public submitFinalAnswer() {
    if (this.settings['mandatory_exam'] == 1 && this.totalNotAnswered == 0 && this.totalVisited == 0) {
      this.examsubmitconfirmSwal.show();
    }
    else if (this.settings['mandatory_exam'] == 0) {
      this.examsubmitconfirmSwal.show();
    } else {
      this.mandatorySwal.show();
    }
  }

  public submitFinalExam(submitType) {

    this.loading = true;
    if (submitType == 'auto') {
      this.autoSubmitAnswers('auto');
      this.isDone = false;
    }
    else {
      this.autoSubmitAnswers('manual');
      this.isDone = true;
    }


  }

  public autoSubmitAnswers(submitType) {
    this.spinner.show();
    this.examService.endDescriptive(this.globals.root_url, this.userData['usercode'], this.settings['exam_id'], this.userData['id'])
      .pipe(first())
      .subscribe(
        data => {

          if (data.code == 1000) {
            this.globals.isExamOver = true;

            clearInterval(this.interval);
            sessionStorage.setItem('pkshn_dexam_time', '0:0');
            if (this.settings['typing_exam'] == 1) {
              this.router.navigateByUrl('/typing-simulation/'+this.settings['exam_id']);
            } 
            else{
              if (submitType == 'manual') {
                //this.router.navigateByUrl('/login');
                document.getElementById('submited-area').style.display = 'none';
                document.getElementById('thanks-area').style.display = 'block';
              }
              else {
                document.getElementById('submited-area').style.display = 'none';
                document.getElementById('thanks-area').style.display = 'block';
              }
            }           
          }
          else {
            this.loading = false;
            // this.router.navigateByUrl('/login');
          }
          this.spinner.hide();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
          //this.router.navigateByUrl('/login');
        }
      );

  }

  public backFromFinalSubmit() {
    document.getElementById('question-area').style.display = 'block';
    document.getElementById('submited-area').style.display = 'none';
    document.getElementById('exit-test').style.display = 'block';
  }


  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

  /* Check Submitted question and jump to next */
  private getNextIndex(type, index) {
    let questDb = this.visitedQuesObj;
    if (Object.keys(this.visitedQuesObj).length < 1) {
      return index;
    }
    else if (type == 'next') {
      for (var i = index; i < this.totalQuestion; ++i) {
        if (questDb[i] != 'submited')
          return i;
      }
      if (index != 1)
        return index;
      else
        return index - 1;
    }
    else if (type == 'prev') {
      for (var i = index; i > 0; --i) {
        if (questDb[i] != 'submited')
          return i;
      }
      return index + 1;
    }
  }

  /* Go to full screen */
  public requestFullscreen(ele) {
    if (ele.requestFullscreen) {
      ele.requestFullscreen();
    } else if (ele.webkitRequestFullscreen) {
      ele.webkitRequestFullscreen();
    } else if (ele.mozRequestFullScreen) {
      ele.mozRequestFullScreen();
    } else if (ele.msRequestFullscreen) {
      ele.msRequestFullscreen();
    } else {
      console.log('Fullscreen API is not supported.');
    }
  };


   //myTimeout;
  /* Text to speech */
  public textToSpeech() {
    var navUserAgent = navigator.userAgent;
    let speechHtml = this.question + '. \n';
    for (var i = 0; i < this.options.length; ++i) {
      speechHtml += this.optionIndexText[i] + ' ? ';
      speechHtml += this.options[i].optiontext + '. \n';
    }
    speechSynthesis.cancel();
    var myTimeout = setTimeout(function () {
        speechSynthesis.pause();
        speechSynthesis.resume();
    }, 15000);     
    var msg = new SpeechSynthesisUtterance();
    var voices = window.speechSynthesis.getVoices(); //console.log(voices);
    for(var i = 0; i < voices.length ; i++) {
        if(voices[i].lang == 'hi-IN')
        {
            msg.voice = voices[i];
        }
    }    
/*    if(navUserAgent.indexOf("Opera") > -1) 
    {
         //msg.voice = voices[7];
    }else if(navUserAgent.indexOf("Chrome") > -1)
    {
       msg.voice = voices[12];
    }else if(navUserAgent.indexOf("MSIE") > -1 || navUserAgent.indexOf("rv:") > -1)
    {
         //msg.voice = voices[7];
    }else if(navUserAgent.indexOf("Firefox") > -1)
    {
         //msg.voice = voices[7];
    }
    else if(navUserAgent.indexOf("Safari") > -1)
    {
         //msg.voice = voices[7];
    }
    else if(navUserAgent.indexOf("OP") > -1)
    {
         //msg.voice = voices[7];
    }  
    else if(navUserAgent.indexOf("Edg") > -1)
    {
         //msg.voice = voices[25];
    } */    
    msg.volume = 1; // 0 to 1
    msg.rate = 1; // 0.1 to 10
    msg.pitch = 0; //0 to 2
    msg.text = speechHtml;
    msg.lang = this.speechLang; //hi-IN hindi india, en-GB great briten
    speechSynthesis.speak(msg);              
    msg.onend = function(e) {
      speechSynthesis.cancel();
      clearTimeout(myTimeout);
    }; 
  }




  public gotoHome() {
    sessionStorage.setItem('pkshn_exam_time','0:0');
    sessionStorage.setItem('pkshn_dexam_time','0:0');
    sessionStorage.removeItem("pkshn_exam_set");        
    sessionStorage.removeItem("pkshn_exam_time");  
    sessionStorage.removeItem("pkshn_select_exam_ps");      
    sessionStorage.removeItem("pkshn_dexam_time");      
    sessionStorage.removeItem("pkshn_feedsetting");     
    this.router.navigateByUrl('/login');
  }

  public questionAnswerTimer(time_taken) {
    this.timeTaken = 0;
    if (typeof time_taken == 'undefined' || time_taken == null)
      time_taken = 0;

    this.timeTaken = time_taken;
    this.intervaltime = setInterval(() => {
      this.timeTaken++;
    }, 1000);
  }
    display ='none'; //default         
    freezetext: string = '';
    descriptiveFreeze() {
            this.examService.examFreezeStatus(this.globals.root_url, this.userData['id'], this.userData['usercode'], this.settings['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    this.spinner.hide();
                    if (data.code == 1000) {
                        if (Number(data.freeze) == 1) {
                            this.isPause = true;
                            this.freezestatus = data.freeze;
                            this.freezetext = data.status; //console.log(this.freezetext);
                            this.display='block';
                        }
                        else if (Number(data.freeze) == 0) {
                            this.isPause = false;
                            //console.log('call==>', data.freeze)
                            this.display='none';
                        }

                    }
                    else {
                        this.loading = false;
                    }
                },
            );
    }  
    languages: any;
    getLanguages() {
            this.examService.getGLanguages(this.globals.root_url, this.userData['id'], this.userData['usercode'], this.settings['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    this.spinner.hide();
                    if (data.code == 1000) {
                      this.languages = data.languages;
                      //console.log(this.languages);
                    }
                    else {
                        this.loading = false;
                    }
                },
            );
    } 
    secLanguages: any;
    primary_lang_name: string;
    primary_lang_code: string;      
    getSecondaryLang() {
            this.examService.getSecLanguages(this.globals.root_url, this.settings['module'], this.userData['usercode'], this.settings['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    this.spinner.hide();
                    if (data.code == 1000) {
                      this.secLanguages = data.languages;
                      this.primary_lang_name = data.primary_lang_name;
                      this.primary_lang_code = data.primary_lang_code;
                      this.currentlanguage = data.primary_lang_code;
                    }
                    else {
                        this.loading = false;
                    }
                },
            );
    }        
} 
